import AuthPage from "./AuthPage";
import React, { useState } from 'react';
import SendMessageButton from './SendMessageButton';
import Groups, { Group } from './Groups';
import './MainPage.css';
import './PunditWelcomePage.css';

const PunditWelcomePage = () => {
    return (
        <div className="punditWelcomePage">
            <h1>Chat With An Astrologer!</h1>
            <AuthPage></AuthPage>
        </div>



    );
};

export default PunditWelcomePage;
